import React, {useContext} from 'react';

import styled from 'styled-components';

import {VideoManagerContext} from 'app/general/VideoManagerProvider';
import {VideoObject} from 'app/video/components/VideoObject';

import type {VideoSerializedType} from 'sweet-types';

interface Props {
  video?: VideoSerializedType;
  videoPlaceholder?: string;
  width: number;
  height: number;
  coverImage?: string;
}

export const EmbeddedObject = ({
  video,
  videoPlaceholder,
  width,
  height,
  coverImage,
}: Props) => {
  const context = useContext(VideoManagerContext);
  return (
    <StyledEmbeddedContainerDiv
      style={{
        width,
        height,
      }}
    >
      {video != null ? (
        <VideoObject
          ratio={getRatio(width, height)}
          videoPlaceholder={videoPlaceholder}
          width={width}
          height={height}
          video={video}
          canAutoplay={context.canAutoplay()}
          videoStartedPlaying={context.videoStartedPlaying}
          videoStoppedPlaying={context.videoStoppedPlaying}
        />
      ) : coverImage != null ? (
        <div
          className="embedded-obj"
          style={{
            paddingBottom: getRatio(width, height),
          }}
        >
          <img src={coverImage} />
        </div>
      ) : null}
    </StyledEmbeddedContainerDiv>
  );
};

export const getRatio = (width: number, height: number) =>
  ((height / width) * 100).toPrecision(4) + '%';

export const StyledEmbeddedContainerDiv = styled.div`
  margin: 10px auto;
  max-width: 100%;
  clear: both;

  .embedded-obj {
    position: relative;
    padding-bottom: 67.5%;
    height: 0;
    overflow: hidden;

    > * {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;
